import { useEffect } from 'react';

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://innoflex.com';

const schemas = [
  {
    id: 'innoflex-organization',
    data: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'INNOFLEX',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/221e836cb47596545a3a537d495fa5e5/2baae45286386b606f279993b0bc93de.jpeg',
        width: 200,
        height: 200,
      },
      description:
        'Software de facturación electrónica e-CF DGII certificado y soluciones tecnológicas a la medida para negocios en República Dominicana y Latinoamérica.',
      areaServed: ['DO', 'LATAM'],
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+1-849-538-8899',
          contactType: 'customer service',
          availableLanguage: 'Spanish',
          contactOption: 'TollFree',
        },
      ],
      sameAs: [],
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'C. Nicolás Ureña de Mendoza 55, Los Prados',
        addressLocality: 'Santo Domingo',
        addressCountry: 'DO',
        addressRegion: 'Distrito Nacional',
        postalCode: '10131',
      },
    },
  },
  {
    id: 'innoflex-website',
    data: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'INNOFLEX',
      description:
        'Software de facturación electrónica e-CF, sistemas de gestión, apps móviles, páginas web y consultoría tecnológica para negocios.',
      inLanguage: 'es',
      publisher: {
        '@id': `${siteUrl}/#organization`,
      },
    },
  },
  {
    id: 'innoflex-software',
    data: {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      '@id': `${siteUrl}/#software`,
      name: 'INNOFLEX Sistema de Facturación',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web, iOS, Android',
      offers: [
        {
          '@type': 'Offer',
          name: 'Plan Starter',
          price: '29.99',
          priceCurrency: 'USD',
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: 29.99,
            priceCurrency: 'USD',
            referenceQuantity: { '@type': 'QuantitativeValue', value: 1, unitCode: 'MON' },
          },
          description: 'Facturación / POS básico, clientes y productos, inventario básico, dashboard de ventas, reportes simples y soporte estándar en horario laboral.',
        },
        {
          '@type': 'Offer',
          name: 'Plan Business',
          price: '59.99',
          priceCurrency: 'USD',
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: 59.99,
            priceCurrency: 'USD',
            referenceQuantity: { '@type': 'QuantitativeValue', value: 1, unitCode: 'MON' },
          },
          description: 'Todo el Plan Starter más compras y proveedores, cuentas por cobrar/pagar, alertas de stock bajo, listas de precios y soporte WhatsApp con prioridad estándar.',
        },
        {
          '@type': 'Offer',
          name: 'Plan Pro',
          price: '99.99',
          priceCurrency: 'USD',
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: 99.99,
            priceCurrency: 'USD',
            referenceQuantity: { '@type': 'QuantitativeValue', value: 1, unitCode: 'MON' },
          },
          description: 'Todo el Plan Business más inventario avanzado, contabilidad operativa, alertas inteligentes, reportes gerenciales, roles y permisos avanzados, modo offline y soporte prioritario.',
        },
        {
          '@type': 'Offer',
          name: 'Plan Premium',
          price: '149.99',
          priceCurrency: 'USD',
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: 149.99,
            priceCurrency: 'USD',
            referenceQuantity: { '@type': 'QuantitativeValue', value: 1, unitCode: 'MON' },
          },
          description: 'Todo el Plan Pro más multi-sucursal, dashboards avanzados, mensajes masivos segmentados, chatbot/WhatsApp/IA básica con límite, auditoría de usuarios y soporte prioritario con incidencias críticas 24/7.',
        },
        {
          '@type': 'Offer',
          name: 'Plan Personalizado',
          priceCurrency: 'USD',
          priceSpecification: {
            '@type': 'PriceSpecification',
            priceCurrency: 'USD',
            minPrice: 299,
          },
          description: 'Para cadenas, clínicas, distribuidoras, supermercados, grupos gastronómicos y empresas con procesos personalizados. Usuarios, cajas y sucursales según alcance, módulos por industria, integraciones, API, IA/WhatsApp según consumo, SLA acordado y desarrollo a medida. Precio bajo cotización.',
        },
      ],
      url: siteUrl,
      publisher: {
        '@id': `${siteUrl}/#organization`,
      },
      description:
        'Sistema integral de facturación electrónica e-CF DGII certificada, gestión de inventario, control de cajas, reportes financieros y herramientas avanzadas para negocios en República Dominicana.',
      featureList: [
        'Facturación electrónica e-CF DGII certificada',
        'Comprobante Fiscal Electrónico (e-CF) integrado',
        'Control de inventario en tiempo real',
        'Gestión de cajas y empleados',
        'Reportes financieros avanzados',
        'Funciona sin conexión a internet',
        'Acceso desde cualquier dispositivo',
        'Sistema de citas integrado',
        'Bot de WhatsApp para ventas',
        'Gestión multi-sucursal',
        'Catálogo digital',
        'Certificación e-CF vía RepublicaFEL',
      ],
    },
  },
  {
    id: 'innoflex-local-business',
    data: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      '@id': `${siteUrl}/#localbusiness`,
      name: 'INNOFLEX',
      url: siteUrl,
      telephone: '+1-849-538-8899',
      image: 'https://static.readdy.ai/image/221e836cb47596545a3a537d495fa5e5/2baae45286386b606f279993b0bc93de.jpeg',
      description:
        'Empresa de software y tecnología especializada en facturación electrónica e-CF DGII, sistemas de gestión, apps móviles, páginas web y consultoría para negocios en RD y Latinoamérica.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'C. Nicolás Ureña de Mendoza 55, Los Prados',
        addressCountry: 'DO',
        addressRegion: 'Distrito Nacional',
        addressLocality: 'Santo Domingo',
        postalCode: '10131',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 18.4861,
        longitude: -69.9312,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '08:00',
          closes: '13:00',
        },
      ],
      priceRange: '$29.99 - $149.99 USD/mes',
      currenciesAccepted: 'USD, DOP',
      paymentAccepted: 'Cash, Credit Card, Bank Transfer',
    },
  },
  {
    id: 'innoflex-faqpage',
    data: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '¿Qué incluye InnoFlex?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Facturación electrónica, control de inventario, gestión de cajas y empleados, reportes financieros en tiempo real, acceso desde celular, sistema de citas, bot de WhatsApp y ventas por catálogo digital — todo en una sola plataforma.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Funciona sin internet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. InnoFlex opera en modo offline. Puedes seguir vendiendo y facturando sin conexión. Los datos se sincronizan automáticamente cuando vuelve la señal.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Desde qué dispositivos puedo acceder?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Desde cualquier dispositivo: celular, tablet, laptop o escritorio. Solo necesitas el navegador o la app — sin instalaciones complejas.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Cuánto tarda la implementación?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Desde 48h tu sistema está activo y tu equipo capacitado (el tiempo depende del tipo de empresa). Nosotros manejamos toda la configuración técnica — tú solo te enfocas en tu negocio.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Trabajan solo en República Dominicana?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Nuestra base principal está en RD, pero trabajamos con negocios en toda Latinoamérica de forma remota sin ningún problema.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Están certificados para facturación electrónica?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Contamos con proveedor certificado de facturación electrónica e-CF (Comprobante Fiscal Electrónico), cumpliendo todas las normativas fiscales de la DGII sin complicaciones adicionales. La certificación e-CF se gestiona a través de nuestro partner oficial RepublicaFEL.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Qué documentos fiscales genera el sistema?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'e-CF (Comprobante Fiscal Electrónico), notas de crédito y débito, recibos de pago y todos los documentos requeridos por la DGII — generados automáticamente con cada transacción a través del portal RepublicaFEL.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Qué es el e-CF y cómo lo contrato?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'El e-CF (Comprobante Fiscal Electrónico) es el documento fiscal digital requerido por la DGII en República Dominicana. Con InnoFlex lo contratas como add-on por $300 (pago único) a través de nuestro partner oficial RepublicaFEL. La activación toma 3 a 5 días hábiles e incluye configuración completa ante la DGII.',
          },
        },
        {
          '@type': 'Question',
          name: '¿También hacen desarrollo de software a la medida?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Absolutamente. InnoFlex es una empresa completa de diseño y desarrollo de software. Creamos apps móviles, sistemas internos, plataformas web y más — todo adaptado exactamente a tu negocio.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Qué pasa si necesito más funciones?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'InnoFlex escala contigo. Puedes agregar módulos, sucursales o funciones personalizadas en cualquier momento sin cambiar de plataforma.',
          },
        },
        {
          '@type': 'Question',
          name: '¿El precio incluye actualizaciones y soporte?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. La mensualidad incluye el sistema completo, actualizaciones automáticas, soporte según tu plan y acceso a nuevas funciones sin costo adicional.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Puedo probar el sistema antes de pagar?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Demo gratuita y personalizada sin compromiso ni tarjeta de crédito. Agenda directo en el calendario y en 1 hora te mostramos todo.',
          },
        },
      ],
    },
  },
  {
    id: 'innoflex-webpage',
    data: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'INNOFLEX — Software de Facturación e-CF & Soluciones Tecnológicas para Negocios',
      description:
        'INNOFLEX ofrece software de facturación electrónica e-CF certificada DGII y soluciones tecnológicas a la medida para restaurantes, supermercados, ferreterías y más. Comprobante Fiscal Electrónico, actívate desde 48h.',
      inLanguage: 'es',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      datePublished: '2024-01-01',
      dateModified: '2026-03-27',
    },
  },
];

function injectSchema(id: string, data: object): HTMLScriptElement {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
  return script;
}

export default function HomeSEO() {
  useEffect(() => {
    const injected: HTMLScriptElement[] = [];
    schemas.forEach(({ id, data }) => {
      injected.push(injectSchema(id, data));
    });
    return () => {
      injected.forEach((el) => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, []);

  return null;
}
